import React from 'react';
import { useQuery } from 'react-query';
import Cookies from 'js-cookie';
import { Navigate, useLocation } from 'react-router-dom';
import { useLogin } from '../hooks/useLogin';
import { useClientId } from '../context/context';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { authenticate } = useLogin();
  const clientId = useClientId();

  const token = Cookies.get(`${clientId}_token`);

  const {
    data: authenticateData,
    error: authenticateError,
    isLoading: authenticateIsLoading,
  } = useQuery(['authenticateData'], () => authenticate({ token }), {
    enabled: !!token,
    retry: false,
    staleTime: 1000 * 60 * 30, // 30 minutes
    cacheTime: 1000 * 60 * 60, // 1 hour
    refetchOnWindowFocus: false,
  });
  

  // 1. No token? Send to login.
  if (!token) {
    return <Navigate to={`/${clientId}/admin/login`} state={{ from: location }} replace />;
  }

  // 2. While authenticating, show loading.
  if (authenticateIsLoading) {
    return <p>Loading...</p>;
  }

  // 3. Failed to authenticate or wrong client? Redirect to login.
  if (
    authenticateError ||
    !authenticateData ||
    authenticateData.data.clientId !== clientId
  ) {
    return <Navigate to={`/${clientId}/admin/login`} state={{ from: location }} replace />;
  }

  // 4. Success! Show protected children.
  return children;
};

export default ProtectedRoute;
